import { getDateByProvider, parseDateIntoTime } from "@/src/app/Offers/EditOffer/ChangeYachtDetailsModal/ChangeYachtDetailsModal";

export const resolveDate = (
  bookingDate: string | undefined,
  offerDate: string | undefined,
  provider: "NS" | "BM" | "CYA" | "Helm" | "Yachtfolio",
  type: "start" | "end"
) => {
  return bookingDate
    ? parseDateIntoTime(bookingDate)
    : offerDate
      ? parseDateIntoTime(offerDate)
      : getDateByProvider(provider)[type];
}
